<template>
  <section class="pswp pa-photo-swipe" tabindex="-1" role="dialog" aria-hidden="true" ref="photoSwipe">
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>
      <div class="pswp__ui pswp__ui--hidden">

        <div class="pswp__top-bar">
          <div class="pswp__counter"></div>
          <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

          <!-- <span class="rotation-wrapper">
            <i class="material-icons">rotate_left</i>
            <i class="material-icons">rotate_right</i>
          </span> -->

          <button class="pswp__button pswp__button--share" title="Share"></button>
          <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
          <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip"></div>
        </div>
        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
         <!-- @click='resetAngle' -->
        </button>
        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
        <!-- @click='resetAngle' -->
        </button>
        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

// https://github.com/rap2hpoutre/vue-picture-swipe/blob/master/src/VuePictureSwipe.vue
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

export default {
  data(){
    return {
      options : {
        index         : 0,
        shareButtons  : [
          {id:'download', label:'電子異界極報取出', url:'{{raw_image_url}}', download:true}
        ],
      }
    };
  },

  computed : {
    images(){
      return this.$store.state.photoSwipe.images;
    },

    imageIndex(){
      return this.$store.state.photoSwipe.imageIndex;
    },

    photoSwipe(){
      return this.$refs.photoSwipe;
    }
  },

  watch : {
    images : {
      handler(data){
        if(data.length === 0) return;

        this.initializePhotoSwipe();
      }
    },
  },

  methods : {
    initializePhotoSwipe(){
      this.options.index = this.imageIndex;

      const photoSwipeObj = new PhotoSwipe(
        this.photoSwipe,
        PhotoSwipeUI_Default,
        this.images,
        this.options
      ); 
      
      photoSwipeObj.listen('imageLoadComplete', (index, item) => {
        if (item.h < 1 || item.w < 1) {
          let img = new Image();

          img.onload = () => {
            item.w = img.width;
            item.h = img.height;

            photoSwipeObj.invalidateCurrItems();
            photoSwipeObj.updateSize(true);
          };

          img.src = item.src;
        }
      });

      photoSwipeObj.listen('destroy', () => {
        this.$store.dispatch({
          type  : 'photoSwipe/clearImages'
        });
      });

      photoSwipeObj.init();
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-photo-swipe{
  .pswp__bg{
    background:linear-gradient(0deg, rgba($body-background-semi-light-darker, .95), rgba($body-background-darker, .9));
    backdrop-filter: blur(3px) opacity(.9);
  }
  .pswp__img--placeholder--blank{
    background:linear-gradient(0deg, rgba($body-background-semi-light-darker, .99), rgba($body-background-darker, .96));
  }
}
</style>